import { useCallback, useState } from 'react';
import { type ModalAnimationState } from '@direct-frontend/components';

export function useDeferModalUnmount(isOpen: boolean) {
    const [keepMountedForExitAnimation, setKeepMountedForExitAnimation] = useState(false);

    if (isOpen && !keepMountedForExitAnimation) {
        setKeepMountedForExitAnimation(true);
    }

    const shouldRenderContent = isOpen || keepMountedForExitAnimation;

    const onModalAnimationEnd = useCallback(
        (animationState: ModalAnimationState) => {
            if (animationState === 'close' && !isOpen) {
                setKeepMountedForExitAnimation(false);
            }
        },
        [isOpen]
    );

    return { shouldRenderContent, onModalAnimationEnd };
}
